var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: { tabindex: "-1", role: "dialog" }
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-xl", attrs: { role: "document" } },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "h4",
                { staticClass: "modal-title", attrs: { id: "myModalLabel" } },
                [
                  _vm._v(
                    _vm._s(_vm.$t("revobase.users.accounts.editModal.title"))
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _vm.userId
              ? _c("div", { staticClass: "modal-body" }, [
                  _c(
                    "div",
                    { staticClass: "mb-3" },
                    [
                      _c("label", [
                        _vm._v(
                          _vm._s(_vm.$t("revobase.users.accounts.hqAccount"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("HqAccountEditor", {
                        ref: "hqAccountEditor",
                        attrs: { userId: _vm.userId }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.userId === _vm.sessionUserId
                    ? _c(
                        "div",
                        { staticClass: "mb-3" },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "revobase.users.accounts.accountsOfInterest"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("AccountsOfInterestEditor", {
                            ref: "accountsOfInterestEditor"
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "button", disabled: _vm.saving },
                  on: { click: _vm.dismiss }
                },
                [_vm._v(_vm._s(_vm.$t("btnClose")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button", disabled: _vm.saving },
                  on: { click: _vm.save }
                },
                [
                  _vm.saving
                    ? _c("Spinner", { attrs: { small: true } })
                    : _vm._e(),
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("btnSave")) + "\n        "
                  )
                ],
                1
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }